import { modes } from "../modes";
import { permissions } from "../permissions/permissions";
import { roles } from "../roles";

export const flagsPermissionProfile = {
    VIEW_FLAGS: {
        [modes.EDIT]: [roles.OWNER],
        [modes.EDIT_PERMISSION]: [permissions.FLAGS.VIEW_FLAGS, permissions.FLAGS.EDIT_FLAGS]
    },
    EDIT_FLAGS: {
        [modes.EDIT]: [roles.OWNER],
        [modes.EDIT_PERMISSION]: [permissions.FLAGS.EDIT_FLAGS]
    }
}